import script from "./FilialProvedorFiscalModal.vue?vue&type=script&setup=true&lang=js"
export * from "./FilialProvedorFiscalModal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__